import React from 'react'

type ProjectIndicatorProps = {
    label: string;
    value: number;
    className: string;
};

const ProjectAvatar = ({ label, value, className }: ProjectIndicatorProps) => {

    return (
        <div className={className}>
            <p style={{ textAlign: 'center' }}>{value}</p>
            <p style={{ fontSize: '0.8rem' }}>{label.toUpperCase()}</p>
        </div>
    );
}

export default ProjectAvatar